export const LOGIN = '/';
export const DASHBOARD = '/dashboard';
export const LOGOUT = '/dashboard/logout';
export const REGISTER = '/register';
export const LOGIN_IMG = '../img/image1.jpg';
export const LOGO_IMG = '../img/bl_mono.png';